module.exports = __webpack_public_path__ + "media/images/icons/SVG/062-b6334cba82c094f2bfb6da10efc0e87a.svg";